import _ from 'lodash';
import { ref, computed } from 'vue-demi';

/** Should match "MD" breakpoint in styles! */
export const MOBILE_SCREEN_BREAKPOINT = 900;
export const RESIZE_THROTTLE_TIMEOUT = 200;
export type LAYOUT_TYPE = 'desktop' | 'mobile';

export const layout = {
  breakpoint: ref(MOBILE_SCREEN_BREAKPOINT),
  type: ref('mobile' as LAYOUT_TYPE),
};

export const useLayout = () => {
  const isLayoutDesktop = computed(() => layout.type.value === 'desktop');
  const isLayoutMobile = computed(() => layout.type.value === 'mobile');

  const setLayoutType = (width: number) => {
    layout.type.value = width <= layout.breakpoint.value ? 'mobile' : 'desktop';
  };

  const setLayoutTypeThrottle = _.throttle(() => {
    setLayoutType(window.innerWidth);
  }, RESIZE_THROTTLE_TIMEOUT);

  const setLayoutMobileBreakpoint = (breakpoint: number) => {
    layout.breakpoint.value = breakpoint;
    setLayoutType(window.innerWidth);
  };

  const startLayoutTypeTracking = () => {
    setLayoutType(window.innerWidth);
    window.addEventListener('resize', setLayoutTypeThrottle);
  };

  const stopLayoutTypeTracking = () => {
    window.removeEventListener('resize', setLayoutTypeThrottle);
  };

  return {
    layoutType: layout.type,
    setLayoutMobileBreakpoint,
    startLayoutTypeTracking,
    stopLayoutTypeTracking,
    isLayoutDesktop,
    isLayoutMobile,
  };
};
